import * as React from "react";

export const LevelNine = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <circle cx={22} cy={22} r={22} fill="#169FED" />
    <path
      stroke="#fff"
      strokeWidth={2.785}
      d="M12.533 11.836v8.355h9.4m0 0v-8.355m0 8.355h9.4v-8.355m-9.4 8.355v14.273"
    />
  </svg>
);
